import {AppMessageService} from "../service/app-message.service";
import {inject} from "@angular/core";

export class MessageHelper{
  public static showSuccessMessage(message: string, service: AppMessageService) {
    if (message) {
      service.showSuccessMessage('', message);
    } else {
      service.showSuccessMessage('', "Success");
    }
  }

  public static showErrorMessage(message: string, service: AppMessageService) {
    if (message) {
      service.showErrorMessage('', message);
    } else {
      service.showErrorMessage('', 'Something went wrong!');
    }
  }
}
